<div class="ir-area ir-mask th-mask" *ngIf="plugin">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="updatePlugin(editForm.value)">
    <div class="ir-modal--title">
      <div class="ir-line">
        <div class="ir-line-content">
          <span>{{ 'common.edit-properties' | translate : plugin }}</span>
        </div>
      </div>
    </div>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-modal-table">
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'common.description' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <textarea
                  formControlName="description"
                  rows="3"
                  placeholder="{{ 'common.description' | translate }}"
                  class="ir-form-set"
                  innertHtml="description"
                ></textarea>
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'common.slot-path' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <input type="text" formControlName="slotPath" class="ir-form-set" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span>Synchronization Enabled</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <input type="hidden" name="synchronizationEnabled" class="ir-form-set" formControlName="synchronizationEnabled" />
                <div class="ir-line ir-select th-select" (click)="openSynchronizationSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{ synchronizationLabel | translate }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="editForm.invalid"
            [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right" type="submit" *ngIf="processing">
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<modal (modalOutput)="selectSynchronizationMenu($event)" (modalClosed)="onSynchronizationMenuClose($event)" #synchronizationModal></modal>
